let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kPmXi")).then(() => parcelRequire('6Crb3'));